<template>
  <div class="logo__wrapper">

  </div>
</template>

<script>
export default {
  components: {},
  props: {
    width: {
      type: Number,
      default: 100,
    },
  },
  emits: {},
};
</script>

<style scoped>
.logo__wrapper {
  display: block;
}

.st0 {
  fill: #ffffff;
}
.st1 {
  fill: #ba2d21;
}
</style>



// WEBPACK FOOTER //
// src/assets/logos/LogoDigmedia.vue